import { sidebarItems, SidebarItem } from '@/components/sidebar/sidebarData';
import { managementAreaSidebarItems, ManagementAreaSidebarItem } from '@/pages/ManagementArea/managementAreaSidebarData';

/** A menu item a feature's «חדש» chip sits on, as the i18n keys of its path: group first, item last. */
export interface MenuPlace {
  /** Where the menu is: the fund area's (coordinators) or the management area's (office). */
  menu: 'fund' | 'management';
  labelKeys: string[];
}

type AnyItem = SidebarItem | ManagementAreaSidebarItem;

const walk = (items: AnyItem[], menu: MenuPlace['menu'], parents: string[], out: Map<string, MenuPlace[]>) => {
  items.forEach((item) => {
    const path = [...parents, item.text];
    if (item.featureKey) out.set(item.featureKey, [...(out.get(item.featureKey) ?? []), { menu, labelKeys: path }]);
    if (item.children) walk(item.children, menu, path, out);
  });
};

const placesByFeature = (() => {
  const map = new Map<string, MenuPlace[]>();
  walk(sidebarItems, 'fund', [], map);
  walk(managementAreaSidebarItems, 'management', [], map);
  return map;
})();

/**
 * The menu items a feature's announcement puts «חדש» on (HAT-1489), for telling the office in the
 * flag's dialog exactly where its users will see it. Empty for a feature with no item of its own.
 */
export const menuPlacesOf = (featureKey: string): MenuPlace[] => placesByFeature.get(featureKey) ?? [];
